import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseCardComponent } from '@fuse/components/card';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';

@Component({
  selector: 'app-testimonial-type04',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule,FuseCardComponent, RouterLink,HeadingSectionType01Component],
  templateUrl: './testimonial-type04.component.html',
  styleUrl: './testimonial-type04.component.scss'
})
export class TestimonialType04Component implements OnInit {

  public view: any = {
  }

  constructor(public tfmService: TFMService, private route: ActivatedRoute) {
    this.tfmService.getTestimonials().then(res => {
      this.view.testimonials = res;
    });
  }

  ngOnInit(): void {
  }
}
